import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';

export function initBlockCall(parent) {
  if (!parent) return;

  const animationTopRightEl = parent.querySelector(
    '.block-call__animation-top-right',
  );
  const animationTopRight = new ParticleWaveBackground(animationTopRightEl, {
    planeWidth: 6,
    planeHeight: 12,
    widthSegments: 80,
    heightSegments: 120,
    particleSize: 0.03,
    waveHeight: 0.3,
    noiseScale: 3,
    animationSpeed: 8000,
    gradient: [
      { color: '#FFAC99', stop: 0 },
      { color: '#f5f5f500', stop: 100 },
    ],
    rotation: { x: -0.6, y: 0.09, z: -2.2 },
    cameraPosition: [-2, -2.6, 8.4],
    cameraRotation: { x: 0, y: 0, z: 0 },
    autoStart: false,
    hoverRadius: 1,
    hoverStrength: 0.5,
    hoverSpringStiffness: 40,
    hoverSpringDamping: 10,
  });

  const animationBottomLeftEl = parent.querySelector(
    '.block-call__animation-bottom-left',
  );
  const animationBottomLeft = new ParticleWaveBackground(
    animationBottomLeftEl,
    {
      planeWidth: 8,
      planeHeight: 14,
      widthSegments: 100,
      heightSegments: 140,
      particleSize: 0.03,
      waveHeight: 0.3,
      noiseScale: 3,
      animationSpeed: 8000,
      gradient: [
        { color: '#FFAC99FF', stop: 0 },
        { color: '#FFAC9900', stop: 100 },
      ],
      rotation: { x: -0.6, y: 0.09, z: -2.2 },
      cameraPosition: [1, 1.6, 8.4],
      cameraRotation: { x: 0, y: 0, z: 0 },
      autoStart: false,
      hoverRadius: 1,
      hoverStrength: 0.5,
      hoverSpringStiffness: 40,
      hoverSpringDamping: 10,
    },
  );

  ScrollTrigger.create({
    trigger: parent,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => {
      animationTopRight.startAnimation();
      animationBottomLeft.startAnimation();
    },
    onLeave: () => {
      animationTopRight.stopAnimation();
      animationBottomLeft.stopAnimation();
    },
    onEnterBack: () => {
      animationTopRight.startAnimation();
      animationBottomLeft.startAnimation();
    },
    onLeaveBack: () => {
      animationTopRight.stopAnimation();
      animationBottomLeft.stopAnimation();
    },
  });

  const card = parent.querySelector('.block-call__card');
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: card,
      start: 'top 75%',
      toggleActions: 'play none none none',
      // markers: true,
    },
    defaults: { ease: 'powe4.out' },
  });

  const items = parent.querySelectorAll('.block-call__item');
  items.forEach((item) => {
    const title = item.querySelector('.block-call__title');
    if (title) {
      tl.fromTo(
        title,
        {
          clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)',
        },
        {
          clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
          duration: 0.6,
        },
        '<',
      );
    }
    const description = item.querySelector('.block-call__description');
    if (description) {
      tl.from(
        description,
        {
          opacity: 0,
          duration: 0.6,
        },
        '<+=0.2',
      );
    }
  });
}

export function initAllBlockCall(selector = '.js-block-call') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initBlockCall(block));
}
